<p-dialog #dialog header="Cấu hình nhân viên" [(visible)]="isShow" [modal]="true"
  [styleClass]="'ag-modal force-full-width'" [style]="{ width: '800px' }" closeIcon="ci ci-close"
  maximizeIcon="ci ci-maximize" minimizeIcon="ci ci-minimize" [maximizable]="true" [autoZIndex]="true">
  <div class="col-12 md:col-12">
    <form #formElement [formGroup]="formGroup">
      <div class="col-12 md:col-12">
        <validation-summary #validationSummary [formElement]="formElement" [formGroup]="formGroup">
        </validation-summary>
      </div>

      <div class="col-12 md:col-12 p-fluid p-formgrid grid">
        <div class="field col-12 md:col-6">
          <label for="employeeCode">Mã nhân viên <span style="color: red">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.employeeCode" formControlName="employeeCode"
            [readOnly]="true" />
        </div>
        <div class="field col-12 md:col-6">
          <label for="employeeName">Tên nhân viên <span style="color: red">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.employeeName" autocomplete="off"
            formControlName="employeeName" [readOnly]="true" />
        </div>
        <div class="field col-12 md:col-6">
          <label for="unitName">Đơn vị <span style="color: red">*</span></label>
          <!-- <p-dropdown [options]="listUnitCode" [autoDisplayFirst]="false" dropdownIcon="ci ci-chevron-down-1"
            appendTo="body" [(ngModel)]="unitCode" formControlName="unitCode" [filter]="true"
             filterBy="label,value">
          </p-dropdown> -->
          <input type="text" pInputText [(ngModel)]="itemDetail.unitName" autocomplete="off" formControlName="unitName"
            [readOnly]="true" />
        </div>
        <div class="field col-12 md:col-6">
          <label for="provinceName">Tỉnh <span style="color: red">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.provinceName" autocomplete="off"
            formControlName="provinceName" [readOnly]="true" />
        </div>
        <div class="field col-12 md:col-6">
          <label for="jobTitleName">Chức danh <span style="color: red">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.jobTitleName" autocomplete="off"
            formControlName="jobTitleName" [readOnly]="true" />
        </div>
        <div class="field col-12 md:col-6">
          <label for="status">Trạng thái hoạt động</label>
          <p-dropdown [options]="listStatus" [(ngModel)]="itemDetail.status" formControlName="status" appendTo="body">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="managerId">Nhân viên quản lý trực tiếp <span style="color: red">*</span></label>
          <p-dropdown [options]="listManager" [(ngModel)]="itemDetail.managerId" formControlName="managerId"
            appendTo="body">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="salesChannelId">Kênh bán <span style="color: red">*</span></label>
          <p-dropdown [options]="listSalesChannel" [(ngModel)]="itemDetail.salesChannelId"
            formControlName="salesChannelId" appendTo="body">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="notes">Ghi chú</label>
          <textarea rows="5" cols="30" [(ngModel)]="itemDetail.notes" pInputTextarea formControlName="notes"></textarea>
        </div>
      </div>
    </form>
  </div>
  <p-footer>
    <div class="col-12 md:col-12">
      <div class="col-8 md:col-8 fl h-text-left"></div>
      <div class="col-4 md:col-4 fr">
        <button pButton pRipple type="button" label="{{ 'BUTTON.SAVE_CLOSE' | translate }}" icon="pi pi-save"
          [disabled]="submitting" class="p-button mr-2 mb-2" (click)="saveAndClose()"></button>

        <!-- <button pButton pRipple type="button" label="{{'BUTTON.SAVE_CONTINUE' | translate}}" icon="pi pi-save"
          [disabled]="submitting" class="p-button mr-2 mb-2" (click)="save()"></button> -->
      </div>
    </div>
  </p-footer>
</p-dialog>